export default function (e) {
  const swiper = this;
  if ("universal" === 'desktop') {
    swiper.emit('tap click', e);
  } else if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/framework7/components/swiper/swiper-class/components/core/events/onClick.js